import './styles.scss';

import { Link } from '@ets-global/b2c-website-ui';
import classNames from 'classnames';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useAuth, useRouter } from '../../../hooks';
import links from './links';

const AccountMenu = () => {
  const { logout } = useAuth();
  const { t } = useTranslation();
  const { currentRoute } = useRouter();
  const [isLoggingOut, setLoggingOut] = useState(false);

  const doLogout = () => {
    setLoggingOut(true);

    return logout();
  };

  return (
    <nav id={'account-menu'} className={'account-menu'}>
      {links.map((item, key) => {
        return (
          <Link
            key={key}
            to={item.path}
            className={classNames('account-menu__item', {
              'account-menu__item--active': currentRoute.path === item.path,
            })}
            aria-label={t(item.label)}
          >
            <span>
              <Trans>{item.label}</Trans>
            </span>
          </Link>
        );
      })}
      <Link
        onClick={doLogout}
        loading={isLoggingOut}
        className={'account-menu__item'}
        data-cypress="main-logout-link"
        aria-label={t('account.logout.title')}
      >
        <span>
          <Trans>account.logout.title</Trans>
        </span>
      </Link>
    </nav>
  );
};

export default AccountMenu;
